import { useSegmentation } from '@printdeal/segmentation/react';
import { AlgoliaHit } from 'instantsearch.js';
import { INDICES } from '../../../plugins/gatsby-plugin-algolia/helpers/validate-indices';
import { algoliaClickEvent } from '../../services/algoliaSearch/algoliaDataLayer';

export type UserType = 'enduser' | 'reseller' | 'default';

export const INDEX_MAP: Record<UserType, string> = {
  enduser: INDICES.PDP_INDEX_END_USER,
  reseller: INDICES.PDP_INDEX_RESELLER,
  default: INDICES.PDP_INDEX,
};

export const useUserTypeAlgoliaClick = () => {
  const { data: segmentationData } = useSegmentation();

  const getUserType = (): UserType => {
    if (segmentationData?.isEnduser) return 'enduser';
    if (segmentationData?.isReseller) return 'reseller';
    return 'default';
  };

  const updateAlgoliaClickEvent = async (
    item: AlgoliaHit,
    persist: boolean = true,
  ): Promise<void> => {
    const userType = getUserType();
    const indexName = INDEX_MAP[userType];
    const indexToUpdate = { ...item, index: indexName };

    await algoliaClickEvent({ ...item, index: INDICES.PDP_INDEX }, persist);

    if (userType !== 'default') {
      await algoliaClickEvent(indexToUpdate, persist);
    }
  };
  return updateAlgoliaClickEvent;
};
